import { Box, Dialog, InputLabel, Stack, TextField } from "@mui/material";
import { financialDetailsColumns } from "data/supplierPageData";
import { useState } from "react";
import {
	SupplierModalActions,
	SupplierModalHeader,
	modalContentSx,
	modalFormStack,
	supplierModalPaperProps,
} from "../../../shared/supplierUi";

const EditFinancialDetails = ({ data, setData, modalOpen, setModalOpen, submitFunction }) => {
	const [updatedDetails, setUpdatedDetails] = useState(data);

	const handleCloseModal = () => {
		setUpdatedDetails(data);
		setModalOpen(false);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		let obj = {};
		Object.keys(financialDetailsColumns).forEach((col) => (obj[col] = updatedDetails[col]));
		if (typeof submitFunction === "function") submitFunction(obj, setModalOpen);
	};
	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open={modalOpen}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handleFormSubmit}
			PaperProps={supplierModalPaperProps}>
			<SupplierModalHeader title="Edit financial details" subtitle="PAN and bank account information" />
			<Box sx={{ ...modalContentSx, pt: 2.5 }}>
				<Stack direction="row" width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={2} columnGap={1}>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>PAN Number</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.pan_no}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, pan_no: e.target.value })}
							placeholder="Enter Pan No"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Bank Name</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.bank_name}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, bank_name: e.target.value })}
							placeholder="Enter Bank Name"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>IFSC Code</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.bank_ifsc_code}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, bank_ifsc_code: e.target.value })}
							placeholder="Enter IFSC Code"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Bank Account Number</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.bank_acc_no}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, bank_acc_no: e.target.value })}
							placeholder="Enter Account Number"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>MICR Code</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.micr_code}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, micr_code: e.target.value })}
							placeholder="Enter MICR Code"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>RTGS Code</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.rtgs_code}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, rtgs_code: e.target.value })}
							placeholder="Enter RTGS Code"
							required
						/>
					</Stack>
				</Stack>
			</Box>
			<SupplierModalActions onCancel={handleCloseModal} />
		</Dialog>
	);
};

export default EditFinancialDetails;
